import React from 'react';
import MainStore from '../../../MainStore';
import WorkStore from './WorkStore';
import AuthStore from '../../Auth/AuthStore'
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import { observer } from 'mobx-react';
import Alert from '@mui/material/Alert';

const WorkFlagDialog = observer(class WorkFlagDialog extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            flagComment: '',
            count: 0,
            errors: []
        }

        this.handleCommentSave = this.handleCommentSave.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.saveComment = this.saveComment.bind(this);
    }

    handleCommentSave() {
        if (WorkStore.getIsCommentRequired && !this.state.flagComment) {
            let errors = this.state.errors.slice(0);
            if (this.state.count === 0) {
                errors.push("Необходимость заполнить комментарий");
            }
            if (this.state.count === 1) {
                errors.push("Введи комментарий");
            }
            if (this.state.count === 2) {
                errors.push("ВВЕДИ КОММЕНТАРИЙ!!!");
            }
            if (this.state.count === 3) {
                errors.push("Вон то поле сверху, комментарий, напиши его!");
            }
            if (this.state.count === 4) {
                errors.push("Да ты издеваешься??");
            }
            if (this.state.count > 4 && this.state.count < 10) {
                errors.push("...");
            }
            if (this.state.count === 11) {
                errors.push("Ладно, твоя взяла");
            }
            if (this.state.count === 12) {
                errors.push("ОЙ ВСЁ");
            }
            if (this.state.count === 13) {
                errors.push("ОЙ ВСЁ!");
            }
            if (this.state.count === 14) {
                this.saveComment();
                return;
            }
            this.setState({ errors: errors, count: this.state.count + 1 });
        }
        else {
            this.saveComment();
        }

        
    }

    saveComment() {
        this.setState({ errors: [], count: 0 });
        if (WorkStore.commentDialogCallback) {
            WorkStore.commentDialogCallback(this.state.flagComment);
            this.setState({ flagComment: '' });
        }
        else {
            var scope = this;
            MainStore.setMaskVisible();
            var token = localStorage.getItem("token");
            fetch('api/Work/FlagAndComment', {
                method: 'POST',
                body: JSON.stringify({ WorkId: WorkStore.workId, Comment: this.state.flagComment, Flag: WorkStore.newFlag, DelayTo: this.state.delayTo }),
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + token
                }
            }).then(function (res) {
                if (res.status === 401) {
                    MainStore.setMaskUnvisible();
                    AuthStore.openLogin();
                }
                else {
                    res.json().then((result) => {
                        /*if (scope.props.onWorkUpdate) {
                            scope.props.onWorkUpdate(result)
                        }*/
                        WorkStore.updateWork(result);
                        MainStore.setMaskUnvisible();
                        WorkStore.closeCommentDialog();
                        this.setState({ flagComment: '' });
                        //scope.setState({ isCommentDialogOpen: false });
                    }).catch((err) => console.log(err));
                }
            });
        }
    }

    handleChange = name => evt => {
        this.setState({ [name]: evt.target.value });
    }

    handleCommentClose() {
        WorkStore.closeCommentDialog();
    }

    render() {
        return (
            <Dialog
                onClose={this.handleCommentClose}
                aria-labelledby="customized-dialog-title"
                open={WorkStore.getIsCommentDialogOpen}
                maxWidth="md"
                fullWidth
            >
                <DialogTitle id="customized-dialog-title" onClose={this.handleCommentClose}>
                    {WorkStore.flagDialogTitle}
                </DialogTitle>
                <DialogContent dividers>
                    <Typography>
                        <TextField required
                            id="standard-required"
                            label="Комментарий"
                            fullWidth
                            margin="normal"
                            value={this.state.flagComment}
                            multiline
                            onChange={this.handleChange('flagComment')}
                        />
                    </Typography>
                    {this.state.errors.map(e => (<Alert severity="error">{e}</Alert>))}
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.handleCommentSave} color="primary">
                        Сохранить
                    </Button>
                    <Button onClick={this.handleCommentClose} color="primary">
                        Отменить
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
})

export default WorkFlagDialog;